import { render, staticRenderFns } from "./Name.vue?vue&type=template&id=597d2304&"
import script from "./Name.vue?vue&type=script&lang=js&"
export * from "./Name.vue?vue&type=script&lang=js&"
import style0 from "./Name.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports